import * as types from '../mutation-types';

const state = {
  okModal: false,
  renewModal: false,
  badResultModal: false,
  cancelRenewModal: false,
  successCancelRenewModal: false,
  claroTermsFrame: false
};

const getters = {
  isOpenModal: () => modal => state[modal],
  isOpenAnyModal: () => state.okModal || state.renewModal ||
  state.cancelRenewModal || state.successCancelRenewModal || state.badResultModal
};

const actions = {
  toggleModal: ({ commit }, modal) => {
    commit(types.TOGGLE_MODAL, modal);
  },
  openModal: ({ commit }, modal) => {
    commit(types.OPEN_MODAL, modal);
  },
  closeModal: ({ commit }, modal) => {
    commit(types.CLOSE_MODAL, modal);
  }
};

const mutations = {
  [types.TOGGLE_MODAL](_, modal) {
    state[modal] = !state[modal];
  },
  [types.OPEN_MODAL](_, modal) {
    state[modal] = true;
  },
  [types.CLOSE_MODAL](_, modal) {
    state[modal] = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/modals.js